import { render } from "./SiteClosedView.vue?vue&type=template&id=03fc163f&scoped=true"
const script = {}

import "./SiteClosedView.vue?vue&type=style&index=0&id=03fc163f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fc163f"]])

export default __exports__